import {
  Toast,
  Dialog,
  Notify
} from 'vant'
import {
  showToast,
  showLoadingToast,
  showSuccessToast,
  showFailToast,
  closeToast,
  showDialog,
  showNotify,
  closeNotify
} from 'vant';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';

export default function (app) {
  const g = app.config.globalProperties
  app
    .use(Toast)
    .use(Dialog)
    .use(Notify)

  g.$showDialog = showDialog
  g.$showLoadingToast = showLoadingToast
  g.$showToast = showToast
  g.$showSuccessToast = showSuccessToast
  g.$showFailToast = showFailToast
  g.$showNotify = showNotify
  g.$closeNotify = closeNotify
  g.$closeToast = closeToast
  // g.$success = Modal.success
  // g.$error = Modal.error
  // g.$warning = Modal.warning
  // g.$confirm = Modal.confirm
}